module.exports = __webpack_public_path__ + "img/lab_background.71ab222e.jpg";